export default {
  'debts:start': 'Балаға Kaspi&nbsp;Gold картасын аштыру үшін',
  'debts:social-debts': 'Әлеуметтік төлемдерден <br/>{0}&nbsp;₸ қарызыңызды өтеуіңіз керек.',
  'debts:tax-debts': 'Салықтан {0}&nbsp;₸ қарызыңызды өтеуіңіз керек.',
  'debts:tax-and-social-debts': 'Салықтан {0}&nbsp;₸ және <br/>әлеуметтік төлемдерден {1}&nbsp;₸ қарызыңызды <br/>өтеуіңіз керек.',
  'debts:undefined': 'Салықтан  және әлеуметтік <br/>төлемдерден  қарызыңызды <br/> өтеуіңіз керек.',
  'debts:btn': 'Салық төлеу',
  'debts:back-to-main': 'Kaspi.kz бас бетіне қайту',
  'debts:title-how': 'Қарызды қалай төлеймін?',
  'debts:hint-1': 'Мемлекеттік кірістер басқармасына немесе мына нөмірге хабарласыңыз',
  'debts:hint-2': 'Қарыз өтеле салғанда <br/> процесті жалғастыра аласыз.'
}
